/* ============================================================
   Diagnóstico del backend (App Proxy → Railway)
   ------------------------------------------------------------
   Permite ver desde la consola QUÉ expone cada endpoint de la
   Master TCG App: qué se pide, qué responde, cuánto tarda y con
   qué forma vuelven los datos.

   APAGADO POR DEFECTO: mientras no se active no envuelve fetch
   ni escribe en consola, así que no cuesta nada a los clientes.

   Encender:   tcgDebug.on()      (o añadir ?tcgdebug=1 a la URL)
   Apagar:     tcgDebug.off()     (o ?tcgdebug=0)
   Esta pagina: tcgDebug.calls()  que llamo al backend (funciona apagado)
   Historial:  tcgDebug.list()    detalle con payloads (requiere encendido)
   Sondeo:     tcgDebug.probe()   llama a TODOS los endpoints y
                                  resume estado, tiempo y claves
   Uno solo:   tcgDebug.probe('quiz')
   ============================================================ */
(function () {
  'use strict';

  var CLAVE = 'tcgDebug';
  var BASE = '/apps/tcg';

  /* Endpoints que el tema consume hoy. Si se añade uno nuevo a una
     sección, basta con listarlo aquí para que entre en el sondeo. */
  var ENDPOINTS = [
    { ruta: '/perfil', que: 'Perfil del duelista: rango, racha, logros, cupones' },
    { ruta: '/racha', que: 'Racha de visitas y cofres' },
    { ruta: '/compras', que: 'Historial de compras del cliente' },
    { ruta: '/quiz', que: 'Reto diario: ranking mensual' },
    { ruta: '/quiz?tipo=deal', que: 'Reto diario: carta y opciones del dia' },
    { ruta: '/atk', que: 'Duelo de ATK: reto y puntuacion' },
    { ruta: '/pull', que: 'Sobres: boveda, historial y aperturas' },
    { ruta: '/meta?tipo=tier', que: 'Meta competitivo por tiers' },
    { ruta: '/top-ventas', que: 'Mas vendidas del Rincon' },
    { ruta: '/mercado', que: 'Movimientos de precio (suben/bajan)' },
    { ruta: '/launches', que: 'Proximos lanzamientos' },
    { ruta: '/eventos', que: 'Torneos y eventos' },
    { ruta: '/noticias', que: 'Noticias del duelista' },
    { ruta: '/tasas', que: 'Tasas de cambio' },
    /* OJO: YGOPRODeck exige num y offset JUNTOS ("You cannot use only one of
       'offset' or 'num'"). Pedir num suelto devuelve no_cards y parece que el
       proxy esta caido cuando no lo esta. */
    { ruta: '/ygo?fname=dark%20magician&num=1&offset=0', que: 'Proxy del archivo YGOPRODeck' }
  ];

  var registro = [];
  var css = 'background:#2a1f16;color:#e2b45c;padding:2px 6px;border-radius:3px;font-weight:700';

  function encendido() {
    try {
      if (/[?&]tcgdebug=1/.test(location.search)) localStorage.setItem(CLAVE, '1');
      if (/[?&]tcgdebug=0/.test(location.search)) localStorage.removeItem(CLAVE);
      return localStorage.getItem(CLAVE) === '1';
    } catch (e) { return false; }
  }

  /* Resume la forma de la respuesta sin volcar todo el JSON. */
  function forma(dato, prof) {
    prof = prof || 0;
    if (dato === null) return 'null';
    if (Array.isArray(dato)) {
      return '[' + dato.length + ']' + (dato.length && prof < 1 ? ' de ' + forma(dato[0], prof + 1) : '');
    }
    if (typeof dato === 'object') {
      var ks = Object.keys(dato);
      if (prof >= 1) return '{' + ks.length + ' claves}';
      return '{ ' + ks.slice(0, 12).join(', ') + (ks.length > 12 ? ', …' : '') + ' }';
    }
    return typeof dato;
  }

  var api = {
    endpoints: ENDPOINTS,

    on: function () {
      try { localStorage.setItem(CLAVE, '1'); } catch (e) {}
      console.log('%cTCG%c diagnostico ENCENDIDO — recargando…', css, '');
      location.reload();
    },

    off: function () {
      try { localStorage.removeItem(CLAVE); } catch (e) {}
      console.log('%cTCG%c diagnostico apagado — recargando…', css, '');
      location.reload();
    },

    list: function () {
      if (!registro.length) {
        console.log('%cTCG%c sin llamadas al backend en esta pagina todavia.', css, '');
        return registro;
      }
      console.table(registro.map(function (r) {
        return { endpoint: r.endpoint, estado: r.estado, ms: r.ms, forma: r.forma };
      }));
      return registro;
    },

    /* Llamadas que ESTA pagina hizo al backend. Sale del Resource Timing
       del navegador, asi que funciona con el diagnostico apagado y no
       cuesta nada. Es la vista que se quiere el 90% de las veces. */
    calls: function () {
      var e = performance.getEntriesByType('resource').filter(function (r) {
        return r.name.indexOf(BASE) !== -1;
      });
      if (!e.length) {
        console.log('%cTCG%c esta pagina no ha llamado al backend.', css, '');
        return [];
      }
      var filas = e.map(function (r) {
        return {
          endpoint: r.name.replace(location.origin, '').replace(BASE, '') || '/',
          ms: Math.round(r.duration),
          bytes: r.transferSize || 0
        };
      });
      console.table(filas);
      var vistos = {}, dup = [];
      filas.forEach(function (f) {
        if (vistos[f.endpoint]) { if (dup.indexOf(f.endpoint) === -1) dup.push(f.endpoint); }
        vistos[f.endpoint] = 1;
      });
      if (dup.length) console.warn('%cTCG%c llamado mas de una vez: ' + dup.join(', '), css, '');
      return filas;
    },

    /* Sondea los endpoints y resume lo que devuelven.
       SECUENCIAL y con corte por tiempo: lanzarlos todos a la vez llegaba a
       congelar la pestana, y un endpoint lento dejaba el sondeo colgado. */
    probe: function (filtro, msLimite) {
      var lista = ENDPOINTS.filter(function (e) {
        return !filtro || e.ruta.indexOf(filtro) !== -1;
      });
      var limite = msLimite || 8000;
      console.log('%cTCG%c sondeando ' + lista.length + ' endpoint(s), de uno en uno…', css, '');

      var filas = [];
      var cadena = Promise.resolve();
      lista.forEach(function (e) {
        cadena = cadena.then(function () {
          var ctrl = new AbortController();
          var corte = setTimeout(function () { ctrl.abort(); }, limite);
          var t0 = performance.now();
          return fetch(BASE + e.ruta, { signal: ctrl.signal, headers: { Accept: 'application/json' } })
            .then(function (res) {
              clearTimeout(corte);
              var tipo = res.headers.get('content-type') || '';
              return res.text().then(function (txt) {
                var datos = null, nota = null;
                if (tipo.indexOf('json') !== -1) {
                  try { datos = JSON.parse(txt); } catch (x) { nota = 'JSON invalido'; }
                } else {
                  nota = 'no es JSON (' + (tipo.split(';')[0] || 'sin tipo') + ')';
                }
                filas.push({
                  endpoint: e.ruta, que: e.que, estado: res.status,
                  ms: Math.round(performance.now() - t0),
                  kb: +(txt.length / 1024).toFixed(1),
                  forma: nota || forma(datos), datos: datos
                });
              });
            })
            .catch(function (x) {
              clearTimeout(corte);
              filas.push({
                endpoint: e.ruta, que: e.que,
                estado: x && x.name === 'AbortError' ? 'TIMEOUT' : 'ERROR',
                ms: Math.round(performance.now() - t0), kb: 0,
                forma: x && x.name === 'AbortError' ? 'sin respuesta en ' + limite + 'ms' : String(x && x.message || x),
                datos: null
              });
            });
        });
      });

      return cadena.then(function () {
        console.table(filas.map(function (f) {
          return { endpoint: f.endpoint, estado: f.estado, ms: f.ms, kb: f.kb, expone: f.forma };
        }));
        var malos = filas.filter(function (f) { return f.estado !== 200; });
        if (malos.length) {
          console.warn('%cTCG%c ' + malos.length + ' sin 200:', css, '',
            malos.map(function (f) { return f.endpoint + ' → ' + f.estado; }));
        }
        console.log('%cTCG%c respuesta completa en .datos de cada fila del array devuelto', css, '');
        return filas;
      });
    }
  };

  window.tcgDebug = api;

  if (!encendido()) {
    /* Pista discreta y una sola linea: no ensucia la consola del cliente. */
    console.info('%cTCG%c diagnostico del backend disponible: tcgDebug.on()', css, '');
    return;
  }

  /* ── Encendido: se envuelve fetch solo para las rutas del App Proxy ── */
  var original = window.fetch;
  window.fetch = function (entrada, init) {
    var url = typeof entrada === 'string' ? entrada : (entrada && entrada.url) || '';
    if (url.indexOf(BASE) === -1) return original.apply(this, arguments);

    var metodo = (init && init.method) || (entrada && entrada.method) || 'GET';
    var t0 = performance.now();

    return original.apply(this, arguments).then(function (res) {
      var ms = Math.round(performance.now() - t0);
      try {
        res.clone().text().then(function (txt) {
          var datos = null;
          try { datos = JSON.parse(txt); } catch (e) {}
          var fila = {
            endpoint: url.replace(BASE, '') || '/',
            metodo: metodo,
            estado: res.status,
            ms: ms,
            kb: +(txt.length / 1024).toFixed(1),
            forma: datos ? forma(datos) : 'no JSON',
            datos: datos
          };
          registro.push(fila);
          var mal = !res.ok;
          console.groupCollapsed('%cTCG%c ' + metodo + ' ' + fila.endpoint +
            ' → ' + res.status + ' · ' + ms + 'ms · ' + fila.kb + 'kB', css, mal ? 'color:#d11317' : '');
          console.log('expone:', fila.forma);
          if (datos) console.log(datos);
          else console.log(txt.slice(0, 400));
          console.groupEnd();
        });
      } catch (e) {}
      return res;
    });
  };

  console.log('%cTCG%c diagnostico ENCENDIDO · tcgDebug.list() · tcgDebug.probe() · tcgDebug.off()', css, '');
})();
